import { registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./panels.html";
import { eventTypes, fireEvent, registerListener, unregisterAllListeners } from 'util/pubsub';
//import { ApiGatewayManagementApi } from 'aws-sdk'; ORV240708 remove aws-sdk ref

import LightningElementSLDS from 'util/lightningElementSLDS';
import { openSidebar, closeSidebar, addChildToSidebar, clearSidebar } from '../app/appUtil';
class Panels extends LightningElementSLDS {
  constructor(...args) {
    super(...args);
    this.panelList = [];
    this.panelListFetched = false;
    this.renderedCallbackExecuted = false;
    this.dePanels = [];
    this.dePanelDialogs = {};
    this.pdfDoc = void 0;
    this.formHelper = void 0;
    this.dialogHelper = void 0;
    this.iframeUrl = void 0;
  }
  //previouslyVisibleDiv;

  connectedCallback() {
    if (!this.panelListFetched) {
      this.panelListFetched = true;
      let self = this;

      //selected by default
      self.panelList.push({
        key: "None",
        bates: undefined,
        value: "None"
      });
      self.panelList.push({
        key: __g_walletLabel,
        bates: undefined,
        value: "Wallet"
      });
      //CRN240309 ERS asked me to remove this from the list
      // self.panelList.push({
      //     key: __g_purseLabel,
      //     bates: undefined,
      //     value: "Purse"
      // });
      if (__g_DEPanelEndpoint) {
        fetch(__g_DEPanelEndpoint, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          }
        }).then(resp => resp.json()).then(zippiResponse => {
          console.log("success : ", zippiResponse);
          self.dePanels = zippiResponse;
          zippiResponse.forEach(element => {
            self.panelList.splice(1, 0, {
              key: element.id,
              bates: element.bates,
              value: element.label
            });
          });
        }).catch(zippiError => {
          console.log("An error has occured while fetching related files : ", zippiError);
        });
      }
    }
    //ORV240129 fire TOGGLE_WALLET when panel.js is loaded
    fireEvent(window.__g_pageRef, eventTypes.TOGGLE_WALLET, {
      enableWallet: true,
      src: "resources/wallet.html"
    });
  }
  renderedCallback() {
    let self = this;
    if (!this.renderedCallbackExecuted) {
      this.renderedCallbackExecuted = true;
      let panelSelect = this.template.querySelector('.panel-select');
      panelSelect.addEventListener("change", evt => {
        let selectedValue = evt.target.value;
        let selectedDePanel = null;
        for (let i = 0; i < this.dePanels.length; i++) {
          if (self.dePanels[i].id == selectedValue) {
            selectedDePanel = this.dePanels[i];
            break;
          }
        }
        //get reference to all the panels / content divs
        let formHelper = __g_zPDF_formHelper__; //self.formHelper did not work here , need to check the reason
        let walletDiv = formHelper.lwcTemplate.querySelector(".wallet-content");
        let mainPaneDiv = formHelper.lwcTemplate.querySelector(".main-pane-content");
        let xrayContent = formHelper.lwcTemplate.querySelector(".x-ray-content");
        this.iframeUrl = "";
        if (selectedValue === "None") {
          //hide other things
          openSidebar(null, "left");
          walletDiv.classList.add("slds-hidden");

          //show canvas
          mainPaneDiv.classList.remove("slds-hidden");
          if (panelSelect.dataset.previousSelectVal == "Wallet") {
            formHelper.getSendToOptions(getSelectedPersona());
          }
          clearSidebar();
          closeSidebar();
          formHelper.restoreCurPageFormElements(formHelper.pagesInfo.curPage, formHelper.docInfo);
        } else if (selectedValue === "Wallet") {
          displayWallet();
        } else if (selectedValue == "Purse") {
          if (!mainPaneDiv.classList.contains("slds-hidden")) {
            console.log("**** learn from main pane");
            formHelper.preserveCurPageFormElements(formHelper.pagesInfo.curPage, formHelper.docInfo);
          } else if (!xrayContent.classList.contains("slds-hidden")) {
            //if we are on the xray div , read the values from xray adn store it in form helper
            console.log("**** learn from wallet");
            let maxpages = self.pdfDoc.numPages;
            for (let pageNumber = 1; pageNumber <= maxpages; pageNumber++) {
              formHelper.updateCurPageFormElements(pageNumber, formHelper.docInfo);
            }
          }
          mainPaneDiv.classList.add("slds-hidden");
          xrayContent.classList.add("slds-hidden");

          //show wallet (set the appropriate iFrame URL)
          //self.iframeUrl = "https://" + parent.location.host + "/red/wallet";
          self.iframeUrl = "resources/purse.html";
          walletDiv.classList.remove("slds-hidden");
          formHelper.lwcTemplate.querySelector(".wallet-content").querySelector("iframe").src = this.iframeUrl;
        } else if (selectedDePanel) {
          console.log("selectedDePanel : ", selectedDePanel);
          //As discussed with Eric, we are targeting DE Panels for desktop only
          //hide canvas (we would not need to hide the )
          //mainPaneDiv.classList.add("slds-hidden");
          //xrayContent.classList.add("slds-hidden");

          //show wallet (set the appropriate DE Panel URL)
          //let dePanelDialog = self.dePanelDialogs[selectedDePanel.id];

          //if(!dePanelDialog) {

          // let parentUrlParams = new URLSearchParams(window.parent.location.href);
          //parentUrlParams.get("dbID")
          // Use a div instead of an iframe. We need to show modal dialogs, so we need the entire pdf viewer
          // window to display them or else they get squished into the small side iframe.
          // let dePanelIframe = document.createElement("iframe");
          // dePanelIframe.id = "iframeId"
          // dePanelIframe.height = "100%";
          // let attachedId = __g_currentItemMetadata?.metadata?.X_attachedTo ? __g_currentItemMetadata?.metadata?.X_attachedTo : "IGNORE";
          let dePanelDiv = document.createElement("div");
          dePanelDiv.id = "dePanelId";
          dePanelDiv.width = "100%";

          // let src = window.isApiServerAvailable ?
          //     "/api/zippi/forms/HTML/" + selectedDePanel.id :
          //     "/red/zippi/forms/HTML/" + selectedDePanel.id;
          // if (__g_recordId) { src += "?recordId=" +__g_recordId; }
          let src = __g_zApiURL + `zippi/forms/HTML/${selectedDePanel.id}`;
          if (__g_recordId) {
            src += "?recordId=" + __g_recordId;
          }

          // dePanelIframe.style = "width: 100%; margin-left: auto; margin-right: auto;";
          dePanelDiv.style = "width: 100%; margin-left: auto; margin-right: auto;";
          // dePanelIframe.src = src;
          // window.iframeRef = dePanelIframe;
          fetch(src, {
            method: 'GET',
            headers: {
              'Accept': 'text/html'
            }
          }).then(res => res.text()).then(html => {
            clearSidebar();
            addChildToSidebar(dePanelDiv.id, dePanelDiv);
            openSidebar(dePanelDiv.id, "left");
            // Using append() assures that javascript is executed.
            $(dePanelDiv).append(html);
            if (typeof postLoadSidebar !== "undefined") {
              postLoadSidebar();
            }
          }).catch(formsError => {
            clearSidebar();
            closeSidebar();
            console.error("An error occured while fetching DE Panel", formsError);
            // show an error toast message here...
            showError("An error occured while fetching Triage Panel");
          });

          // addChildToSidebar(dePanelIframe.id, dePanelIframe);
          // addChildToSidebar(dePanelDiv.id, dePanelDiv);

          // restructureDOM(dePanelIframe.contentDocument);
          // }

          //let dialog
          //  $(self.dePanelDialogs[selectedDePanel.id]).dialog("open");
          //https://dv29.zpaper.com/kb/zp/getDEPanel.html?BATES=Triage_Panel_Data2_Web_Form&attachedId=IGNORE&dbID=00005019X1g9dllq1f&noPlus=true&sfdcDefinitive=true&saveURL=/kb/jsp/pdfSaveFormWrapper.jsp&dbID2=00005019X1g9dllq1f
          // self.iframeUrl = "https://" + parent.location.host + "/kb/zp/getDEPanel.html?" +
          //                     "BATES=" + selectedDePanel.bates +
          //                     "&attachedId=IGNORE" + 
          //                     "&dbID=" + selectedValue +
          //                     "&noPlus=true" +
          //                     "&sfdcDefinitive=true" +
          //                     "&saveURL=/kb/jsp/pdfSaveFormWrapper.jsp" + 
          //                     "&dbID2=" + selectedValue;
          // walletDiv.classList.remove("slds-hidden");
          // formHelper.lwcTemplate.querySelector(".wallet-content").querySelector("iframe").src = this.iframeUrl;
        }
        panelSelect.dataset.previousSelectVal = evt.target.value;
      });
    }
  }
  setPdfDetails(options) {
    console.log("**options**");
    console.log(options);
    this.pdfDoc = options.pdfDoc;
    this.formHelper = options.formHelper;
    this.dialogHelper = options.dialogHelper;
  }
}
_registerDecorators(Panels, {
  publicMethods: ["setPdfDetails"],
  track: {
    panelList: 1
  },
  fields: ["panelListFetched", "renderedCallbackExecuted", "dePanels", "dePanelDialogs", "pdfDoc", "formHelper", "dialogHelper", "iframeUrl"]
});
export default _registerComponent(Panels, {
  tmpl: _tmpl
});